import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import DesktopBrowseBar from './DesktopBrowseBar';
import MobileBrowseBar from './MobileBrowseBar';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BrowseBar({
  hasActiveOfferingType = true
}) {
  const isMobile = useIsMaxScreenSize('sm');
  return isMobile ? /*#__PURE__*/_jsx(MobileBrowseBar, {}) : /*#__PURE__*/_jsx(DesktopBrowseBar, {
    hasActiveOfferingType: hasActiveOfferingType
  });
}